export function planListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdatePlanId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixCreatePlanId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function planMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixGetManyPlan(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      planId: resource.objectId,
    })),
  };
}